import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-presentacion-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  tamano = document.body.clientHeight;
  CkeditorConfig = {
    height: document.body.clientHeight - 560
  }
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      bancos_id: ['', [Validators.required]],
      no_cuenta: ['', [Validators.required]],
      clabe: ['', [Validators.required]],
      titular: ['', [Validators.required]]
    });
    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById('catalogos').click();
    // let c = 0;
    // this.dato.controls.descripcion.valueChanges.subscribe(val => {
    //   if (val && c == 0) {
    //     c++;
    //     setTimeout(() => {
    //       this.dato.controls.descripcion.patchValue(val);
    //     }, 500);
    //   }
    // });
  }
}
